import z from 'zod';

const paymentSpecificationsSchema = z.object({
  max: z.string(),
  min: z.string(),
  processingTime: z.string(),
  transactionFee: z.string(),
});

export type PaymentSpecifications = z.infer<typeof paymentSpecificationsSchema>;

export const paymentOptionSchema = z.object({
  name: z.string(),
  logoUrl: z.url(),
  deposit: paymentSpecificationsSchema,
  withdrawal: paymentSpecificationsSchema,
});

export type PaymentOption = z.infer<typeof paymentOptionSchema>;
